import { Dispatch, SetStateAction, useState } from "react";
import Image from "next/image";
import { BurgerIcon } from "@/public/icons/BurgerIcon";
import { CrossIcon } from "@/public/icons/CrossIcon";
import { AngleRightIcon } from "@/public/icons/AngleRightIcon";
import { SectionWithLinks } from "@/components/layout/headerLegacy/menuMobile/sectionWithLinks/SectionWithLinks";
import { SectionWithSubSections } from "@/components/layout/headerLegacy/menuMobile/sectionWithSubSections/SectionWithSubSections";
import originFrance from "@/public/images/entreprise_100_pour100_fr_mobil.svg";
import { Menu, SectionType } from "../menuDesktop/MenuDesktop";
import styles from "./MenuMobile.module.scss";

type MenuMobileProps = {
  menu: Menu;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export const MenuMobile = ({ menu, isOpen, setIsOpen }: MenuMobileProps) => {
  const [sectionOpened, setSectionOpened] = useState("");
  const [subSectionOpened, setSubSectionOpened] = useState("");

  const setStateToReset = () => {
    if (subSectionOpened) {
      setSubSectionOpened("");
    } else {
      setSectionOpened("");
    }
  };

  return (
    <div className={styles.menuBurger}>
      {isOpen ? (
        <div
          className={styles.icon}
          onClick={() => {
            setIsOpen(false);
          }}
        >
          <CrossIcon />
        </div>
      ) : (
        <div
          className={styles.icon}
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <BurgerIcon />
        </div>
      )}
      <div>
        <div className={isOpen ? styles.menuIn : styles.menuOut}>
          {sectionOpened && (
            <div onClick={setStateToReset} className={styles.backButton}>
              <div className={styles.leftArrow}>
                <AngleRightIcon color="#445871" />
              </div>
              <p className={styles.backButtonText}>Retour</p>
            </div>
          )}
          {menu.menuSection.map((section, index) => {
            if (section.type === SectionType.SINGLE && section.single) {
              return (
                <SectionWithLinks
                  title={section.title}
                  links={section.single}
                  sectionOpened={sectionOpened}
                  setSectionOpened={setSectionOpened}
                  setIsOpen={setIsOpen}
                  key={index}
                />
              );
            } else if (section.type === SectionType.COLUMN && section.column) {
              return (
                <SectionWithSubSections
                  title={section.title}
                  subSectionsWithLinks={section.column}
                  sectionOpened={sectionOpened}
                  setSectionOpened={setSectionOpened}
                  subSectionOpened={subSectionOpened}
                  setSubSectionOpened={setSubSectionOpened}
                  setIsOpen={setIsOpen}
                  key={index}
                />
              );
            } else if (section.type === SectionType.ROW && section.row?.rows) {
              return (
                <SectionWithSubSections
                  title={section.title}
                  subSectionsWithLinks={section.row.rows}
                  sectionOpened={sectionOpened}
                  setSectionOpened={setSectionOpened}
                  subSectionOpened={subSectionOpened}
                  setSubSectionOpened={setSubSectionOpened}
                  setIsOpen={setIsOpen}
                  key={index}
                />
              );
            }
          })}
          <div className={styles.customerServiceIcon}>
            <a
              target={"_blank"}
              rel="noreferrer"
              className={styles.customerServiceLink}
            >
              <Image
                src={originFrance as unknown as string}
                alt="100% France"
                layout="fill"
              />
            </a>
          </div>
        </div>
        {isOpen && (
          <div
            className={styles.shadow}
            onClick={() => {
              setIsOpen(false);
            }}
          />
        )}
      </div>
    </div>
  );
};
